import Constant from '@/const';
import axios from 'axios';

const putStaff = async payload => {
  try {
    await axios.put(Constant.apiUrl.concat('/master/staff/update'), payload);
  } catch (error) {
    throw new Error(error);
  }
};

export default putStaff;
